<template>
  <v-row align="center">
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }} Faculty</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form lazy-validation autocomplete="off">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="faculty.title"
                    :error="$v.faculty.title.$error"
                    hide-details
                    outlined
                    dense
                  >
                    <template v-slot:label>
                      Title <span class="text-danger">*</span>
                    </template>
                  </v-text-field>
                  <span class="text-danger" v-if="$v.faculty.title.$error"
                    >This Field is required</span
                  >
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="faculty.level_ids"
                    :items="levels"
                    item-text="title"
                    item-value="id"
                    hide-details
                    chips
                    multiple
                    clearable
                    small-chips
                    deletable-chips
                    :error="$v.faculty.level_ids.$error"
                    outlined
                    dense
                  >
                    <template v-slot:label>
                      Level <span class="text-danger">*</span>
                    </template>
                  </v-select>
                  <span class="text-danger" v-if="$v.faculty.level_ids.$error"
                    >This Field is required</span
                  >
                </v-col>

                <v-col cols="12">
                  Status
                  <v-switch
                    v-model="faculty.is_active"
                    :label="faculty.is_active ? 'Yes' : 'No'"
                    outlined
                    dense
                  ></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="createOrUpdate">
            {{ edit ? "Update" : "Save" }}
          </v-btn>
          <v-btn color="red darken-1" dark @click="closeDialog"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import FacultyService from "@/service/faculty/FacultyService";
import LevelService from "@/service/level/LevelService";

const faculty = new FacultyService();
const level = new LevelService();

export default {
  name: "CreateAndUpdate",
  data() {
    return {
      dialog: false,
      edit: false,
      levels: [],
      errors: [],
      faculty: {
        title: "",
        level_ids: [],
        is_active: true
      }
    };
  },
  validations: {
    faculty: {
      title: { required },
      level_ids: { required }
    }
  },
  mounted() {
    this.getAllLevels();
  },
  computed: {
    title() {
      if (this.edit) {
        return "Edit";
      } else {
        return "Create";
      }
    }
  },
  methods: {
    getAllLevels() {
      level
        .all()
        .then(response => {
          this.levels = response.data.data;
        })
        .catch(() => {});
    },
    openDialog() {
      this.dialog = true;
      this.edit = false;
      this.resetForm();
    },
    editDialog(faculty) {
      this.dialog = true;
      this.edit = true;
      this.resetForm();
      this.faculty = faculty;
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.$v.$reset();
      this.faculty = {
        title: "",
        grade_id: "",
        is_active: true
      };
    },
    createOrUpdate() {
      this.$v.$touch();
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 6000);
      } else {
        if (this.edit) {
          faculty
            .update(this.faculty.id, this.faculty)
            .then(response => {
              if (response.data.status === "OK") {
                this.$snotify.success("Faculty updated successfully");
                this.$emit("refresh");
                this.closeDialog();
              }
            })
            .catch(error => {
              this.errors = error.response.data.errors;
            });
        } else {
          faculty
            .store(this.faculty)
            .then(response => {
              if (response.data.status === "OK") {
                this.$snotify.success("Faculty created successfully");
                this.$emit("refresh");
                this.closeDialog();
              }
            })
            .catch(error => {
              this.errors = error.response.data.errors;
            });
        }
      }
    }
  }
};
</script>
